module.exports = __webpack_public_path__ + "static/media/riskScoringSystem.b0a2b7ad.mp3";